/* eslint-disable no-unused-vars */

import { useEffect, useState } from 'react'
import DashboardWrapper from '../../Dashboard/components/DashboardWrapper'
import { HUTRIT_CLUB_UPLOAD_STEPS } from '../constants'
import Challenge from './components/Challenge/Challenge'
import Explanations from './components/Explanations/Explanations'
import JoinHutritClub from './components/JoinHutritClub/JoinHutritClub'
import SuccessView from './components/SuccessView/SuccessView'
import { useHutritClubUploadTalentStore } from './globalStore'
import { useGetProfileUserInfo } from '../../../hooks/useGetProfileUserInfo'
import EditVideo from './components/EditVideo/EditVideo'

const UploadVideoTalent = ({ isMasterClass }) => {
  const { data: userData = {}, isLoading } = useGetProfileUserInfo()

  const { userInfo = {} } = userData
  const alreadyUploadVideo = userInfo?.hutrit_next_videos?.length > 0

  const { currentStep, isEditVideo, setCurrentStep } =
    useHutritClubUploadTalentStore()
  const [uploadVideo] = useState(false)

  useEffect(() => {
    if (userInfo?.training && !isMasterClass && !isLoading) {
      setCurrentStep(HUTRIT_CLUB_UPLOAD_STEPS.challengeTips)
    }
  }, [userInfo?.training, isLoading])

  const renderSteps = {
    [HUTRIT_CLUB_UPLOAD_STEPS.explications]: <Explanations />,
    [HUTRIT_CLUB_UPLOAD_STEPS.challengeTips]: <Challenge userData={userData} />,
    [HUTRIT_CLUB_UPLOAD_STEPS.successView]: <SuccessView />,
  }

  if (isLoading) {
    return <div>CARGANDO...</div>
  }

  return (
    <DashboardWrapper
      dashboardWrapperClassName={
        alreadyUploadVideo ? 'w-100' : 'w-100'
      }
      hideChatBubble
    >
      <JoinHutritClub userData={userData} />
    </DashboardWrapper>
  )
}

export default UploadVideoTalent
